<template>
    <span class="close-modal" @click="closeModal">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path
              d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/></svg>
      <span v-if="withText">{{$t('modal.close')}}</span>
    </span>
</template>

<script>
    export default {
        name: "modal-close-btn",
        props: {
            withText: {
              default: true
            }
        },
        methods: {
            closeModal (e) {
                this.$emit('click', e);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modal-close-btn.vue